import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SkeletonWrapper = styled.div({
  display: 'flex',
  marginBottom: "var(--ds-space-150, 12px)",
  width: '100%',
  padding: "var(--ds-space-100, 8px)",
  marginRight: "var(--ds-space-negative-100, -8px)",
  marginLeft: "var(--ds-space-negative-100, -8px)"
});

// TODO: https://product-fabric.atlassian.net/browse/DSP-1426
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var AvatarContainer = styled.div({
  height: '40px',
  width: '40px',
  backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
  borderRadius: '100%',
  marginRight: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var Column = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
});